module.exports = __webpack_public_path__ + "img/warnning-tip.ff3fd6ad.svg";